<template>
  <div>
    <b-content-header :to="{name: 'CommunityAdminList', params: {rowSize: getRowSize}}">
      <span uk-icon="icon: meeting-list; ratio: 1.5" class="shield" style="color: #fff7a8;"></span>
      <span class="content-header--title">ТС {{ community.name }}</span>
    </b-content-header>
    <WrapperContent>
      <Spinner :isLoading="isLoading">
        <div class="uk-flex uk-flex-between uk-flex-column-reverse@s uk-flex-row@xl">
          <div class="table-wrapper_top">
            <table class="uk-table">
              <tbody>
                <tr>
                  <td class="info-left-col">
                    <span>Название</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      community.name
                    }}</span>
                  </td>
                  <td class="info-left-col">
                    <span>Председатель</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      chairmanName
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="info-left-col">
                    <span>Адрес</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      streetData
                    }}</span>
                  </td>
                  <td class="info-left-col">
                    <span>Описание</span>
                  </td>
                  <td>
                    <span style="width: 350px;" class="b-text-semi_bold b-text-color--nero">{{
                      community.description
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="info-left-col">
                    <span>УНП</span>
                  </td>
                  <td>
                    <span class="b-text-semi_bold b-text-color--nero">{{ community.unp }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="uk-flex uk-flex-center uk-margin-medium-top">
              <b-button name="Редактировать" @click="$modal.show('new-community-form')" />
            </div>
          </div>
          <div class="community-actions">
            <b-button name="Добавить дом" color="red" @click="$modal.show('new-house-form')" />
          </div>
        </div>
      </Spinner>

      <b-table
        ref="tableComponent"
        :header="header"
        :headers="headers"
        :columns="columns"
        :sort="'id'"
        :uri="tableUri"
        class="uk-margin-medium-top"
      />
    </WrapperContent>
    <CreateNewHouseForm :id="id" @save="updateData" />
    <EditPartnershipDialog
      :communityData="community"
      :addressData="address"
      :isEdit="isEdit"
      @save="updateData"
    />
  </div>
</template>

<script>
import BContentHeader from '@/components/b-content-header'
import CreateNewHouseForm from './_dialogs/house-create-form'
import EditCommunityDialog from './_dialogs/community-create-form'

import {mapActions} from 'vuex'
import config from '@/config'

export default {
  name: 'Item',
  components: {
    CreateNewHouseForm,
    BContentHeader,
    EditPartnershipDialog: EditCommunityDialog
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    community: {},
    address: null,
    chairmanName: '',
    uri: 'house/community',
    header: '',
    headers: [],
    columns: [],
    isEdit: true,
    isLoading: false
  }),
  methods: {
    ...mapActions({
      getCommunityDetails: 'community/GET_COMMUNITY_DETAILS',
      getAddressDetails: 'address/GET_ADDRESS_DETAILS',
      getChairmanList: 'chairman/GET_CHAIRMAN_LIST'
    }),
    loadCommunityDetails() {
      this.isLoading = true
      this.getCommunityDetails(this.id)
        .then(resp => {
          this.community = resp
          this.loadAddressDetails()
          this.getChairman()
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.community = {}
        })
    },
    loadAddressDetails() {
      this.getAddressDetails(this.community.addressId)
        .then(resp => {
          this.address = resp
        })
        .catch(err => console.log(err))
    },
    initTable() {
      this.header = 'Список домов'
      this.headers = [{name: '#'}, {name: 'Улица'}, {name: 'Здание'}, {name: ''}]
      this.columns = [
        {name: 'id', type: Number},
        {name: 'streetId', type: 'street'},
        {name: 'building', type: String},
        {name: 'more', type: 'more', url: '/admin/house/list'}
      ]
    },
    updateData() {
      this.initTable()
      this.loadCommunityDetails()
      this.$refs.tableComponent.updateData()
    },
    getChairman() {
      this.getChairmanList()
        .then(resp => {
          let res = resp.content.find(it => it.id === +this.community.chairmanId)
          this.chairmanName = res.fullName
        })
        .catch(err => console.log(err))
    }
  },
  mounted() {
    this.updateData()
  },
  computed: {
    tableUri() {
      return this.uri + '/' + this.id
    },
    streetData() {
      return this.address
        ? `${this.address.elementType}
          ${this.address.evaName},
          д. ${this.address.building},
          пом. ${this.address.roomNumber ? this.address.roomNumber : '-'}`
        : ''
    },
    getRowSize() {
      return +this.$route.query.page * config.TABLE_ROW_COUNT + config.TABLE_ROW_COUNT
    }
  }
}
</script>

<style lang="scss" scoped>
.community-actions {
  display: flex;
  justify-content: flex-end;
}

.info-left-col {
  width: 120px;
}
</style>
